import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';

import { SENDOUT_INTERVIEW_FORM_FIELDS_MAP as FORM_FIELDS_MAP } from '../SendoutInterviewForm.constants';

const STRINGS = strings.sendoutsV2.form.sections.emailNotifications;

export const InterviewEmailNotificationsFields = () => {
  const { control } = useFormContext();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Controller
          name={FORM_FIELDS_MAP.SendEmailToCandidate.key}
          control={control}
          defaultValue={false}
          as={
            <FormControlLabel
              data-testid="send-email-to-candidate-checkbox"
              label={STRINGS.labels.candidate}
              labelPlacement="end"
              control={<Checkbox color="primary" />}
            />
          }
          onChangeName="onChange"
          valueName="checked"
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={FORM_FIELDS_MAP.SendEmailToHiringAuthority.key}
          control={control}
          defaultValue={false}
          as={
            <FormControlLabel
              data-testid="send-email-to-hiring-authority-checkbox"
              label={STRINGS.labels.hiringAuthority}
              labelPlacement="end"
              control={<Checkbox color="primary" />}
            />
          }
          onChangeName="onChange"
          valueName="checked"
        />
      </Grid>
    </Grid>
  );
};
